import React, { ReactNode } from 'react';
import DefaultTooltip from 'components/Utils/DefaultTooltip';
import Icon from 'components/Utils/NewIcon';

const Info = ({ tooltip }: { tooltip: ReactNode }) => {
  return (
    <DefaultTooltip title={tooltip}>
      <span className="info-icon">
        <Icon src="circle-question" className="inline-block ml-[0.6ch] text-[#afafaf]" />
      </span>
    </DefaultTooltip>
  );
};
export default Info;
